import {SearchService} from './SearchService';

export class Pagination<TFacets extends string, ISearchResult> {
	protected _element: JQuery<HTMLElement>;
	protected _next: JQuery<HTMLElement>;
	protected _prev: JQuery<HTMLElement>;
	protected _searchService: SearchService<TFacets, ISearchResult>;
	protected _pageContainer: JQuery<HTMLElement>;

	public constructor(
		element: JQuery<HTMLElement>,
		searchService: SearchService<TFacets, ISearchResult>,
	) {
		this._element = element;
		this._searchService = searchService;
		this._next = $('[data-pagination-next]', element);
		this._prev = $('[data-pagination-prev]', element);
		this._pageContainer = $('[data-pagination-pages]', element);

		this._next.on('click', () => {
			this._searchService.loadNextPage();
		});

		this._prev.on('click', () => {
			this._searchService.loadPreviousPage();
		});

		this._searchService.addResultsListener(() => this.render());
	}

	protected render(): void {
		const maxPage = this._searchService.maxPages - 1;
		const currentPage = this._searchService.currentPage;
		if(maxPage <= 0){
			this._element.hide()
			return;
		} else {
			this._element.show();
		}
		this._next.prop("disabled", currentPage >= maxPage);
		this._prev.prop("disabled", currentPage <= 0);

		const spacer = `<span class="pagination__item">...</span>`
		let paginationButtons = [];
		for (let i = 0; i < this._searchService.maxPages; i++) {
			const classes = ['pagination__item'];
			this._searchService.currentPage == i && classes.push('pagination__item--active');
			const pageButton = $(`
					 <button type="button" class="${classes.join(' ')}">${i+1}</button>
				`).on('click', () => {
				this._searchService.loadPage(i);
			});
			paginationButtons.push(pageButton);
		}

		const itemsAroundCurrentToShow = 1;
		currentPage < (maxPage - itemsAroundCurrentToShow) && paginationButtons.splice(currentPage + itemsAroundCurrentToShow, (maxPage - currentPage - itemsAroundCurrentToShow), spacer)
		currentPage > itemsAroundCurrentToShow && paginationButtons.splice(1, currentPage - itemsAroundCurrentToShow, spacer)
		this._pageContainer.empty().append(paginationButtons);
	}
}



// WEBPACK FOOTER //
// ./scripts/algolia/Pagination.ts